
import { instantiate } from './testKotlinWASM-composeApp.uninstantiated.mjs';


const exports = (await instantiate({
})).exports;

export const {
memory,
_initialize
} = exports


